import { FC } from 'react';

import { IconButton } from '@mui/material';

import { ReactComponent as ArrowsPointingOut } from 'assets/icons/ArrowsPointingOut.svg';

import styles from './FullscreenButton.module.scss';

interface IProps {
  onClick: VoidFunction;
}

export const FullscreenButtonMobile: FC<IProps> = ({ onClick }) => (

  <IconButton className={styles['button-mobile']} onClick={onClick}>
    <ArrowsPointingOut />
  </IconButton>
);
